import React, { Component } from "react";
import { connect } from "react-redux";
import SchoolDetailTop from "../../components/School/SchoolDetail/SchoolDetailTop";
import SchoolDetailDown from "../../components/School/SchoolDetail/SchoolDetailDown";
import SchoolDetailDownPay from "../../components/School/SchoolDetail/SchoolDetailDown/indexPay";
import { get } from "../../utils/request";
import "./style.css";
/**
 * 神奇大学的院校详情页面
 */
class SchoolDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }
  render() {
    const { userInfo } = this.props;
    return (
      <div className="school_detail">
        <SchoolDetailTop
          sheetVisible={true}
          data={this.state.data}
        ></SchoolDetailTop>
        {userInfo.isBuy === true ? (
          <SchoolDetailDownPay
            hashId={
              this.props.from === "/intelligentbigdata/home"
                ? this.props.aHashId
                : this.props.match.params.hashId
            }
            data={this.state.data}
            from="/intelligentbigdata/home"
          ></SchoolDetailDownPay>
          // <SchoolDetailDown
          //   hashId={
          //     this.props.from === "/intelligentbigdata/home"
          //       ? this.props.aHashId
          //       : this.props.match.params.hashId
          //   }
          //   data={this.state.data}
          //   from="/intelligentbigdata/home"
          // ></SchoolDetailDown>
        ) : (
          <SchoolDetailDown
            hashId={
              this.props.from === "/intelligentbigdata/home"
                ? this.props.aHashId
                : this.props.match.params.hashId
            }
            data={this.state.data}
            from="/intelligentbigdata/home"
          ></SchoolDetailDown>
        )}
      </div>
    );
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  componentWillMount() {
    this.requestSchoolDetail();
  }
  componentWillReceiveProps() {
    setTimeout(() => {
      if (
        this.props.from === "/intelligentbigdata/home" &&
        this.props.visible === true
      ) {
        this.requestSchoolDetail();
      }
    });
  }

  /**
   * 请求院校详细信息
   */
  requestSchoolDetail() {
    if (this.props.from === "/intelligentbigdata/home") {
      get("/public/v1/school/detail/" + this.props.aHashId).then((res) => {
        this.setState({
          data: res.data,
        });
      });
    } else {
      let hashId = this.props.match.params.hashId;
      get("/public/v1/school/detail/" + hashId).then((res) => {
        this.setState({
          data: res.data,
        });
      });
    }
  }
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(SchoolDetail);



// WEBPACK FOOTER //
// ./src/containers/SchoolDetail/index.js